export const splitButtonDefaultStyle = (theme, buttonStyle, disabled) => ({
  borderTopRightRadius: '0',
  borderBottomRightRadius: '0',
  marginRight: buttonStyle === 'secondary' && disabled ? '-1px' : '',
  backgroundColor: buttonStyle === 'secondary' && disabled ? `${theme.tokens.ComponentSplitButtonDisabledBg} !important` : ''
});
export const meatBallSplitButtonDefaultStyle = (theme, buttonStyle, disabled) => ({
  ...(buttonStyle === 'secondary' ? {
    marginLeft: '-0.8px'
  } : {}),
  borderTopLeftRadius: '0',
  borderBottomLeftRadius: '0',
  backgroundColor: buttonStyle === 'secondary' && disabled ? `${theme.tokens.ComponentSplitButtonDisabledBg} !important` : ''
});